import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import { message } from 'antd';
import _notification from 'modules/notification';
import { Card, Icon } from 'antd';
import { GENERAL_ERROR_MESSAGE } from 'constants/constants';
import FileUpload from '../../components/controls/FileUpload';
import xls from '../../assets/template/StudentInterviewResultData.xlsx';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import DropdownList from 'components/controls/DropdownList';

class UploadInterviewResult extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            posts: [],
            // Interview Marks Workflow & Final Result Foundation phase: Post context is now required
            // so every uploaded Roll Number can be validated against it server-side, closing the
            // previously-documented limitation that Roll Numbers were trusted as globally unique.
            selectedPostId: null,
            uploadedDoc: "",
            fileError: "",
            loading: false,
            uploadErrorMessage: ""
        };
    }

    componentDidMount() {
        this.loadPosts();
    }

    loadPosts = async () => {
        try {
            const response = await _AdminService.GetAllPost();
            this.setState({ posts: response.data || [] });
        } catch (e) { }
    }

    onPostChange = (e) => {
        this.setState({ selectedPostId: parseInt(e.target.value, 10) || null });
    }

    handleUpload = async (input) => {
        if (!this.state.selectedPostId) {
            message.error("Select a Post first.");
            return;
        }
        if (this.state.uploadedDoc && this.state.fileError == "") {
            try {
                this.setState({ loading: true }, async () => {
                    try {
                        var formData = new FormData()
                        formData.append('file', this.state.uploadedDoc)

                        const response = await _AdminService.ImportStudentInterviewResult(this.state.selectedPostId, formData);
                        if (response.status == 200 && response.data.IsSuccess == true) {
                            message.success("File uploaded successfully.")
                            this.setState({
                                uploadedDoc: "",
                                fileError: "",
                                loading: false,
                            });
                        }
                        else {

                            let responseMessage = response.data.Message;
                            this.setState({
                                loading: false,
                                uploadErrorMessage: responseMessage
                            });

                            if (responseMessage == "" || responseMessage == null || responseMessage == undefined) {
                                _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                            }
                        }
                    } catch (e) {
                        // TODO
                        this.setState({ loading: false });
                        console.log('Error: ', e);
                        message.error(GENERAL_ERROR_MESSAGE)
                    }
                });
            } catch (e) { }
        } else {
            message.error("Select file to upload")
        }
    }

    onFileDrop = (file) => {
        //console.log(file);
        this.setState({ uploadedDoc: file, fileError: '', uploadErrorMessage: "" });
    }

    onFileError = (errorMsg) => {
        console.log(errorMsg);
        this.setState({ fileError: errorMsg })
    }


    render() {

        if (this.state.loading)
            return <LoadingSpinner/>

        return (
            <div className="container-fluid p-3">
                <div style={{ textAlign: 'right' }}>
                    <div className="max1200 m-auto mb-2">
                        <div className="d-flex align-items-center justify-content-end">
                            <a className="button-global button-border addbutton autoWidth d-inline-block text-center autoHeight mb-3 mr-2 d-flex align-items-center justify-content-center"
                                href={xls} download="StudentInterviewResultData.xlsx"><Icon type="download" className="mr-2 font1rem" /> Download Template</a>
                        </div>
                    </div>
                </div>
                <div className="max1200 m-auto">
                    <div className="whiteBg gl-bxbr p-4 mb-4">
                        <h4 className="heading4">Upload Interview Result file </h4>
                        <div className="admin-inner-wrap p-3">

                            <div className="row mb-3">
                                <div className="col-sm-6">
                                    <DropdownList
                                        value={this.state.selectedPostId || 0}
                                        name="postId"
                                        onChange={this.onPostChange}
                                        placeholder="Select Post"
                                        heading="Post/Exam"
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={true}
                                        options={this.state.posts}
                                    />
                                </div>
                            </div>

                            <div className="mb-2 col-sm-12 uploadCard">
                                <FileUpload onFileDrop={this.onFileDrop} onError={this.onFileError} />
                                {this.state.fileError ? <label className="textAlignCenter" htmlFor="password"><span className="color-red">Error: {this.state.fileError}</span></label> : <></>}
                            </div>
                            {this.state.uploadErrorMessage != "" ?
                                <Card className="mb-2 col-sm-12 pb-3 uploadErrorMsgAlign">
                                    {this.state.uploadErrorMessage != "" ?
                                        <span className='color-red' dangerouslySetInnerHTML={{ __html: this.state.uploadErrorMessage }}></span> :
                                        <></>}
                                </Card>
                                :
                                <></>
                            }
                        </div>
                        <div className="pt-4 buttonAlignCenter" >
                            <button type="button" disabled={this.state.uploadErrorMessage != "" ? true : false} onClick={this.handleUpload} className="button-global button-primary autoHeight small"><span>Upload File</span></button>
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}

export default UploadInterviewResult;
